import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"clipPath":"url(#clip0_101749_96872)"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.234 18L6.23404 2H22.5V18H22.234Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.4101 22.0045L22.0002 23.4144L16.5858 18H6.87574L1.5 22.7038V2.91421L0.585938 2.00015L2.00015 0.585938L2.0043 0.590088L2 0.594389L23.4101 22.0045Z"}}]}]};

const ChatOffFilled = Vue.extend<IconProps>({
  name: 'ChatOffFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chat-off-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChatOffFilled;
